import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import AgGrid from '../../shared/agGrid/agGrid.component';
import { calcSettingsTaxRatesColumnDefs } from '../../shared/columnDefinitions/taxRates';

export const TaxRatesPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    countryTaxType: PropTypes.string,
    description: PropTypes.string,
    taxRate: PropTypes.string,
    overrideExists: PropTypes.string,
    utilizedTaxRate: PropTypes.number,
    currencyCode: PropTypes.string,
    bsAccount: PropTypes.string,
    plAccount: PropTypes.string,
    overrideTaxRate: PropTypes.number,
  })
);

class TaxRates extends PureComponent {
  static propTypes = {
    taxRates: TaxRatesPropTypes,
  };

  render() {
    const { taxRates } = this.props;

    return (
      <div className="tax-rates container-fluid">
        <div className="row">
          <div className="col">
            <div className="calc-settings-grid">
              <AgGrid
                columnDefs={calcSettingsTaxRatesColumnDefs}
                rowData={taxRates}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TaxRates;
